var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"re-form-item"},[_c('label',{staticClass:"re-form-item__label",style:({width: this.Form.labelWidth})},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"re-form-item__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }